import { checkboxClasses, FormControl, FormHelperText, FormLabel, Grid, Icon, typographyClasses } from '@mui/material';
import { useField } from 'formik';

import Checkbox from 'Lib/components/common/Checkbox';

import HelperText from './HelperText';
const CheckboxInput = ({ index, name, option, onChange, bindFilterValue, stopPropagation }) => (
	<Grid item xs={12} key={`${option.label}_${index}`}>
		<Checkbox
			data-cy={option.label}
			color="success"
			label={option.label}
			value={option.value}
			name={name}
			checkboxProps={{
				checked: bindFilterValue(option),
				checkedIcon: <Icon>check_box</Icon>,
				disableRipple: true,
				icon: <Icon>check_box_outline_blank</Icon>,
				value: option.value,
				onClick: e => stopPropagation && e.stopPropagation(),
				onChange
			}}
			sx={{
				mr: 0,
				mb: 3,
				alignItems: 'end',
				[`& .${typographyClasses.root}`]: { fontSize: theme => `${theme.typography.pxToRem(16)} !important` },
				[`& .${checkboxClasses.root}`]: { py: 0 }
			}}
		/>
	</Grid>
);

export default function ChecklistField({ name, label, options, stopPropagation, sx, required, onChange }) {
	if (name) {
		const [field, meta, helper] = useField(name);

		const handleOnChange = event => {
			if (onChange) {
				onChange(event);
			}

			if (event.target.checked) {
				const values = Array.isArray(field.value) ? field.value : field.value ? [field.value] : [];
				values.push(event.target.value);
				helper.setValue(values.sort());
			} else {
				if (Array.isArray(field.value)) {
					helper.setValue(field.value.filter(v => v != event.target.value).sort());
				} else {
					helper.setValue([]);
				}
			}
		};

		const bindFilterValue = option => {
			if (Array.isArray(field.value)) return field.value.some(v => v == option.value);
			else return field.value == option.value;
		};

		return (
			<FormControl fullWidth sx={sx ? sx : { mt: 6 }} error={!!meta.error} required={required}>
				{label && (
					<FormLabel id={`${label}-checkboxes`} sx={{ fontSize: theme => theme.typography.pxToRem(14), fontWeight: 'medium', letterSpacing: '0.1px' }}>
						{label}
					</FormLabel>
				)}
				<Grid container justifyContent="space-between">
					{options.map((option, index) => (
						<CheckboxInput
							key={`${option.label}_${index}`}
							index={index}
							option={option}
							name={name}
							onChange={handleOnChange}
							bindFilterValue={bindFilterValue}
							stopPropagation={stopPropagation}
						/>
					))}
				</Grid>
				{required && (
					<FormHelperText>
						<HelperText meta={meta} required={required} />
					</FormHelperText>
				)}
			</FormControl>
		);
	} else {
		return (
			<FormControl fullWidth sx={sx ? sx : { mt: 6 }}>
				{label && (
					<FormLabel id={`${label}-checkboxes`} sx={{ fontSize: theme => theme.typography.pxToRem(14), fontWeight: 'medium', letterSpacing: '0.1px' }}>
						{label}
					</FormLabel>
				)}
				<Grid container justifyContent="space-between">
					{options.map((option, index) => {
						const [field, __, helper] = useField(option.name);

						const onChange = event => {
							if (event.target.checked) {
								helper.setValue(option.value);
							} else {
								helper.setValue(option.uncheckedValue || null);
							}
						};

						const bindFilterValue = option => {
							return field.value == option.value;
						};

						return (
							<CheckboxInput
								key={`${option.label}_${index}`}
								index={index}
								option={option}
								name={name}
								onChange={onChange}
								bindFilterValue={bindFilterValue}
								stopPropagation={stopPropagation}
							/>
						);
					})}
				</Grid>
			</FormControl>
		);
	}
}
